import store from '../store';
import axios from 'axios';
axios.defaults.baseURL = BangeoHost;

export default {
	createIdentityVerification: (verificationType) => {
		console.info("COGNITO_createIdentityVerification");
		console.time("COGNITO_createIdentityVerification");

		const user = store.state.user.user;

		if (user) {
			return axios.post('/api/v1/user/verify-identity/create', {
				verification_type: verificationType
			});
		} else {
			return Promise.reject(new Error('User not found'));
		}
	},
	verifyIdentityCallback: (token) => {
		console.info("COGNITO_verifyIdentityCallback");
		console.time("COGNITO_verifyIdentityCallback");

		if (!token) {
			return Promise.reject(new Error('Token is required'));
		}

		return axios.post('/api/v1/user/verify-identity/callback', { token });
	}
}
